//action
import {
    GET_TEST_CATEGORIES,
    GET_TEST_CATEGORIES_FAIL,
    GET_TEST_CATEGORIES_SUCCESS,
    GET_TEST_CATEGORIES_RESET
} from "../action/getTestCategoriesAction"
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    list: [],
    pagination: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_TEST_CATEGORIES:
            return {
                ...state,
                apiState: "loading"
            }
        case GET_TEST_CATEGORIES_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_TEST_CATEGORIES_SUCCESS:
            return {
                ...state,
                apiState: "success",
                list: action.response.data.data.testCategory,
            }
        case GET_TEST_CATEGORIES_RESET:
            return initialState
        default:
            return state
    }
}